// src/components/destination-properties-carousel/destination-properties-carousel.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query DestinationPropertiesCarouselQuery(\n    $context: ContextInput!\n    $propertySearchCriteriaInput: PropertySearchCriteriaInput\n    $title: String\n    $dataType: String\n  ) {\n    destinationPropertiesCarousel(context: $context, criteria: $propertySearchCriteriaInput, title: $title, dataType: $dataType) {\n      ...LodgingCarouselContainerFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { EGDSFigureAspectRatioType } from "@egds/react-core/images";
import { useBexApi } from "@shared-ui/bex-api-context";
import { LodgingCarouselContainer, LodgingCarouselPlaceholder, ProductShoppingInvokeFunctionProvider } from "@shared-ui/lodging-fragments";
// src/utils/constants.ts
var REVIEWS = "REVIEWS";
// src/components/destination-properties-carousel/destination-properties-carousel.tsx
var __Query = gql(_templateObject(), LodgingCarouselContainer.fragment);
var DestinationPropertiesCarousel = function(props) {
    var filteredCarouselCards = function filteredCarouselCards(propertyCarousel) {
        var filteredCards = propertyCarousel.items.filter(function(item) {
            var hasMedia = item.mediaSection.gallery && item.mediaSection.gallery.media && item.mediaSection.gallery.media.length > 0;
            var hasHeading = item.headingSection && item.headingSection.heading && item.headingSection.heading.length > 0;
            return hasHeading && hasMedia;
        });
        return _object_spread_props(_object_spread({}, propertyCarousel), {
            items: filteredCards
        });
    };
    var inputs = props.inputs, skipSsr = props.skipSsr, clickstreamConfig = props.clickstreamConfig, dataType = props.dataType, withCardBorder = props.withCardBorder, cardHeadingSize = props.cardHeadingSize, isRouteAndHoverDifferent = props.isRouteAndHoverDifferent;
    var context = useBexApi().context;
    var isReview = dataType === REVIEWS;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context,
        dataType: dataType
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading) {
        return /* @__PURE__ */ React.createElement(LodgingCarouselPlaceholder, null);
    }
    if (error || !(data === null || data === void 0 ? void 0 : data.destinationPropertiesCarousel)) {
        return null;
    }
    var filteredCarouselItems = filteredCarouselCards(data.destinationPropertiesCarousel);
    if (filteredCarouselItems.items.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React.createElement(ProductShoppingInvokeFunctionProvider, null, /* @__PURE__ */ React.createElement(LodgingCarouselContainer, {
        data: filteredCarouselItems,
        isReview: isReview,
        peek: true,
        pageBy: 1,
        aspectRatio: EGDSFigureAspectRatioType.R4_3,
        clickstreamConfig: clickstreamConfig,
        isRecommendationModule: !isReview,
        itemsVisible: {
            lg: 4,
            md: 2,
            sm: 1
        },
        margin: {
            blockstart: "six"
        },
        tag: "h2",
        withCardBorder: withCardBorder,
        cardHeadingSize: cardHeadingSize,
        isRouteAndHoverDifferent: isRouteAndHoverDifferent
    }));
};
DestinationPropertiesCarousel.displayName = "sharedui-DestinationPropertiesCarousel";
export { DestinationPropertiesCarousel };
//# sourceMappingURL=index.js.map